import React, { useState, useEffect } from "react";

const RecordingTimer = () => {
  const [timer, setTimer] = useState({ minutes: 0, seconds: 0 });

  useEffect(() => {
    const interval = setInterval(() =>
      setTimer((prev) => {
        if (prev.seconds === 59) return { minutes: prev.minutes + 1, seconds: 0 };
        return { ...prev, seconds: prev.seconds + 1 };
      }), 1000
    );
    return () => clearInterval(interval);
  }, []);

  const pad = (n) => (n < 10 ? "0" + n : n);

  return (
    <span className="mx-2.5 text-sm font-mono tabular-nums text-slate-700 dark:text-slate-300">
      {`${pad(timer.minutes)}:${pad(timer.seconds)}`}
    </span>
  );
};

export default RecordingTimer;
